module.exports = __webpack_public_path__ + "img/trash.e1496836.svg";